import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData,
  type CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostError,
  type CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostResponse,
  createCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPost,
} from '../../generated';

export type CreateCollectionMutationVariables =
  CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData['path'] &
    CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData['body'];

export type CreateCollectionMutation = CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostResponse;

export const useCreateCollectionMutation = <
  TError = CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateCollectionMutation, TError, CreateCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateCollectionMutation, TError, CreateCollectionMutationVariables, TContext>({
    mutationKey: ['CreateCollection'],
    mutationFn: async ({ workspace_id, ...body }: CreateCollectionMutationVariables) => {
      const { data } = await createCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPost({
        path: { workspace_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateCollectionMutation.fetcher = (
  { workspace_id, ...body }: CreateCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPost({
      path: { workspace_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
